module.exports = __webpack_public_path__ + "img/wmcxyl.0210f765.png";